import type { SxProps, Theme } from '@mui/material/styles';
import { Color } from 'shared/utils/colors';

export const columnSettingsButtonSx: SxProps<Theme> = {
  color: 'text.primary',
  alignSelf: 'center',
  '&:hover': {
    backgroundColor: Color.primaryOrangeHover,
  },
  '&:active': {
    backgroundColor: Color.primaryOrangeActive,
  },
};
